// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Row = styled<any, Theme>('tr')`
  &:nth-child(odd) {
    background-color: ${props => props.theme.packageCompare.rowBackground};
  }
`;

export default Row;
